import { render, staticRenderFns } from "./samba.vue?vue&type=template&id=1866edc2&"
import script from "./samba.vue?vue&type=script&lang=js&"
export * from "./samba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports